import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TableRowColumn } from 'material-ui/Table';
import MobianDateTimeInput from 'components/input/MobianDateTimeInput';

class DateTimeTableCell extends Component {
    state = {
        touched: false,
        error: null,
    };

    onChange = (eventValue, event) => {
        if (!event) {
            return;
        }

        const { value, onChangeInput, name } = this.props;

        const values = { ...value };

        let _eventValue = eventValue;

        if (event.target.type && (event.target.type === event.target.name)) {
            _eventValue = eventValue.substring(0, 10);
        }

        event.target.id = value.id;
        event.target.name = name;
        event.target.value = _eventValue;

        this.setState({
            touched: true,
        });

        return onChangeInput(event, values);
    }

    render() {
        const { value: values, name, style } = this.props;
        const { touched, error } = this.state;

        const value = values[name] || undefined;

        return (
            <TableRowColumn style={ style }>
                <MobianDateTimeInput
                    input={ {
                        onChange: this.onChange,
                        name: name,
                        value: value,
                    } }
                    meta={ {
                        touched: touched,
                        error: error,
                    } }
                    type='datetime-local'
                />
            </TableRowColumn>
        );
    }
}

DateTimeTableCell.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string,
    ]).isRequired,
    name: PropTypes.string.isRequired,
    onChangeInput: PropTypes.func.isRequired,
    style: PropTypes.object,
};

export default DateTimeTableCell;


// WEBPACK FOOTER //
// ./src/pages/products/configuration/DateTimeTableCell.js